import React from 'react';

const PrimaryImageContext = React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'setUrl':
      return { ...state, mediaUrl: action.payload };
    case 'showModal':
      return { ...state, showModal: true };
    case 'hideModal':
      return { ...state, showModal: false };
    case 'submit':
      return { ...state, mediaUrl: action.payload, showModal: false };
    default:
      throw new Error();
  }
};

export default PrimaryImageContext;
export { reducer };
